var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M2.52 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M2.52 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M10.92 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 0a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 8.12a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04M19.32 16.24a2.52 2.52 0 1 1 0 5.04 2.52 2.52 0 0 1 0-5.04"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.bda26daeaea17a4292620504bb393452.svg";
export { ForwardRef as ReactComponent };